/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function TerritoriesEditViewController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $route: JS5Object,
    $routeParams: JS5Object,
    $timeout: JS5Function,
    uiGridConstants: JS5Object,
    BreadcrumbService: JS5Object,
    MediaAcceptProfileService: JS5Object,
    ModalService: JS5Object,
    NotificationService: JS5Object,
    PermissionsService: JS5Object,
    SidebarService: JS5Object,
    TerritoriesService: JS5Object,
    UtilsService: JS5Object,
) {
    this.editData = {};
    const getData = () => {
        this.loadingIndicator.show = true;
        TerritoriesService.getTerritory($routeParams.id).then((territory: JS5Object) => {
            TerritoriesService.originalEditData = _.cloneDeep(territory);
            this.editData = territory;
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };


    const saveHandler = () => {
        this.loadingIndicator.show = true;
        this.editData.iSO2Code = _.toUpper(this.editData.iSO2Code);
        this.editData.iSO3Code = _.toUpper(this.editData.iSO3Code);
        if ($routeParams.id === '-1') {
            saveNewTerritory();
        }
        else {
            updateTerritory();
        }
    };
    const updateTerritory = () => {
        TerritoriesService.updateTerritory(this.editData).then((territory: JS5Object) => {
            TerritoriesService.originalEditData = _.cloneDeep(territory);
            this.editData = territory;
            this.editorForm.$setPristine();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };
    const saveNewTerritory = () => {
        TerritoriesService.createTerritory(this.editData).then((territory: JS5Object) => {
            $route.updateParams({id: territory.id});
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };


    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => !_.get(this.editorForm, '$pristine')
                && _.size(_.get(this.editData, 'name'))
                && _.size(_.get(this.editData, 'value'))
                && _.size(_.get(this.editData, 'iSO2Code')) === 2
                && _.size(_.get(this.editData, 'iSO3Code')) === 3,
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: () => {
                this.editData = _.cloneDeep(TerritoriesService.originalEditData);
                this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: () => !_.get(this.editorForm, '$dirty'),
            onClick: () => $location.url(`/system/properties/search`).search({tab: 'Territories'})
        }
    ];

    this.$onInit = () => {
        SidebarService.editService = TerritoriesService;
        this.isAdmin = PermissionsService.isAdmin();
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };


        if (this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {

                    BreadcrumbService.addBreadcrumb({
                        name: 'Create Territory',
                        location: '/system/properties/search',
                        params: {tab: 'Territories'}
                    });
                }
                getData();
            } else {
                this.allowTerritoryTypeEdit = true;
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Territory',
                    location: '/system/properties/search',
                    params: {tab: 'Territories'}
                });
            }
        } else {
            $location.url('/login');
        }
    };

    this.validateInput = ($event: JS5Object, currentValue: JS5Object, regexString: string) => {
        UtilsService.inputValidatorByRegExpString($event, currentValue, regexString);
    };

    this.$onDestroy = () => {
        TerritoriesService.originalEditData = null;
        TerritoriesService.viewData = null;
    };

    this.$postLink = () => {
        $timeout(() => {
            TerritoriesService.editorForm = this.editorForm;
            BreadcrumbService.editService = TerritoriesService;
        });
    };
}


angular.module('prism-ui.territories').component('territoriesEditView', {
    templateUrl: 'system/territories/editor/territories-edit-view-template.html',
    controller: TerritoriesEditViewController,
    bindings: {
    }
});
